export const state = {
  typeToLayer: {
    0: 'PlanetScope',
    1: 'PlanetVars',
    2: 'PlanetSkySat'
  },
  layers: [],
  dates: [],
  selectedRange: null,
  orgLayers: {},
  selectedFeature: {
    feature: null,
    coordinates: null,
    isVisible: false
  },
  // Track active result per layer for chart-map interaction
  activeResults: {},
  // Batch-fetched subscription results by orgId and layerCode
  subscriptionResults: {},
  // PlanetScope mosaic selection per layer (detail page writes, sidebar variant reads)
  planetscopeSelection: {},
  // Mapbox view toggles (labels / 3D buildings / 3D terrain) per map, for URL sharing
  mapViewSettings: {},
  // Order product bundle selection per layer (detail page writes, sidebar variant reads)
  orderProductBundle: {},
  // PlanetVars quarter selection per layer (detail page writes, sidebar variant reads)
  planetVarsSelection: {},
  // LULC active month per parent layer (detail chart hover writes, sidebar variant reads).
  // Keyed by parent layers.code; value is the active layer_lulc child code.
  lulcActiveMonths: {},
  // Temporary client-only layers (keyed by orgId, not persisted)
  tempLayers: {},
  // Multi-select: keyed by orgId, value is { [layerCode]: true }
  selectedLayers: {},
  // Copy/paste clipboard for a single layer: { orgId, layerCode, name } or null
  clipboardLayer: null
}
